<template>
  <p class="d-flex justify-content-center">{{msg}}</p>
</template>

<script>
export default {
  props: {
    msg: '',
  },

  data() {
    return {
      //
    };
  },

  created() {
    //
  },

  methods: {
    //
  },
};
</script>

<style scoped>

</style>
